export const legalContent = {
  it: {
    privacy: {
      eyebrow: "Informative legali",
      title: "Privacy Policy",
      updated: "Ultimo aggiornamento: 23/09/2026",
      back: "Torna alla Home",
      intro:
        "Questa informativa descrive come vengono trattati i dati personali degli utenti del sito vetrina di Ristorante Gunè, ai sensi del Regolamento UE 2016/679 (GDPR).",
      sections: [
        {
          h: "1. Titolare del trattamento",
          p: [
            "Il titolare del trattamento è Ristorante Gunè, con sede in Via XXV Aprile 80, 37014 Castelnuovo del Garda (VR), contattabile al numero +39 045 640 2529.",
            "Per qualsiasi richiesta relativa ai propri dati è possibile rivolgersi al titolare tramite i contatti sopra indicati.",
          ],
        },
        {
          h: "2. Dati raccolti",
          p: [
            "Il sito è puramente informativo: non sono previste registrazioni, aree riservate né acquisti online (nessun e-commerce).",
            "I dati personali (nome, numero di telefono, eventuale indirizzo email, data e ora della prenotazione e note facoltative) vengono raccolti esclusivamente tramite il modulo di richiesta di prenotazione, su base volontaria dell'utente.",
          ],
        },
        {
          h: "3. Finalità e base giuridica",
          p: [
            "I dati sono trattati al solo fine di gestire le richieste di prenotazione e di ricontattare l'utente per confermare il tavolo.",
            "La base giuridica del trattamento è l'esecuzione di misure precontrattuali su richiesta dell'interessato; per eventuali comunicazioni ulteriori verrà richiesto il consenso.",
          ],
        },
        {
          h: "4. Conservazione dei dati",
          p: [
            "I dati sono conservati per il tempo strettamente necessario a gestire la richiesta e vengono poi cancellati o resi anonimi.",
            "Non vengono effettuate profilazioni né decisioni automatizzate.",
          ],
        },
        {
          h: "5. Comunicazione a terzi",
          p: [
            "I dati non vengono venduti né diffusi. Possono essere trattati da fornitori tecnici (ad es. hosting e gestione del database) incaricati del trattamento secondo l'art. 28 del GDPR.",
          ],
        },
        {
          h: "6. Diritti dell'interessato",
          p: [
            "L'utente può esercitare in ogni momento i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione (artt. 15-22 del GDPR), rivolgendosi al titolare.",
            "È inoltre possibile proporre reclamo al Garante per la protezione dei dati personali.",
          ],
        },
        {
          h: "7. Aggiornamenti",
          p: [
            "La presente informativa può essere modificata in qualsiasi momento; si invita a consultare periodicamente questa pagina.",
          ],
        },
      ],
    },
    terms: {
      eyebrow: "Informative legali",
      title: "Termini e Condizioni",
      updated: "Ultimo aggiornamento: 23/09/2026",
      back: "Torna alla Home",
      intro:
        "Le presenti condizioni regolano l'utilizzo del sito vetrina di Ristorante Gunè. L'accesso e la navigazione implicano la loro accettazione.",
      sections: [
        {
          h: "1. Oggetto",
          p: [
            "Il sito ha finalità esclusivamente informative e promozionali: non sono previste vendite online, pagamenti né contrattualistica elettronica (nessun e-commerce).",
          ],
        },
        {
          h: "2. Informazioni, menu e immagini",
          p: [
            "Contenuti, prezzi e piatti indicati hanno scopo divulgativo e possono variare nel tempo; le immagini sono indicative.",
            "Il menu completo è fornito tramite una piattaforma esterna (thecubedesign.it) e si apre in una nuova scheda; Ristorante Gunè non è responsabile dei contenuti di siti di terzi, così come delle mappe e dei servizi integrati di Google.",
          ],
        },
        {
          h: "3. Richieste di prenotazione",
          p: [
            "L'invio del modulo di prenotazione costituisce una semplice richiesta: la prenotazione si intende confermata solo dopo il contatto telefonico da parte del ristorante.",
          ],
        },
        {
          h: "4. Proprietà intellettuale",
          p: [
            "Il logo, i testi e le fotografie presenti sul sito sono di proprietà di Ristorante Gunè o dei legittimi titolari e non possono essere riprodotti senza autorizzazione scritta.",
          ],
        },
        {
          h: "5. Limitazioni di responsabilità",
          p: [
            "Il titolare non garantisce la costante disponibilità del sito né l'assenza di errori o interruzioni, e può modificare contenuti e presenti condizioni in qualsiasi momento.",
          ],
        },
        {
          h: "6. Legge applicabile e foro competente",
          p: [
            "Le presenti condizioni sono regolate dal diritto italiano. Per ogni controversia è individuato il foro di Verona, salvo le competenze imperative di legge.",
          ],
        },
      ],
    },
    cookies: {
      eyebrow: "Informative legali",
      title: "Cookie Policy",
      updated: "Ultimo aggiornamento: 23/09/2026",
      back: "Torna alla Home",
      intro:
        "Questa pagina spiega cosa sono i cookie, quali vengono utilizzati da questo sito e come gestirli.",
      sections: [
        {
          h: "1. Cosa sono i cookie",
          p: [
            "I cookie sono piccoli file che il sito salva sul dispositivo dell'utente tramite il browser: servono a garantire il funzionamento, ricordare preferenze e raccogliere statistiche aggregate.",
          ],
        },
        {
          h: "2. Cookie tecnici",
          p: [
            "Il sito utilizza cookie e meccanismi tecnici necessari al suo funzionamento, come il salvataggio della preferenza linguistica (italiano/inglese). Trattandosi di strumenti indispensabili per la navigazione richiesta dall'utente, non richiedono consenso.",
          ],
        },
        {
          h: "3. Cookie di misurazione (analytics)",
          p: [
            "Il sito può avvalersi di strumenti di analisi del traffico in forma aggregata e anonimizzata, al fine di comprendere l'utilizzo delle pagine e migliorare l'esperienza di navigazione.",
            "Non vengono utilizzati cookie di profilazione pubblicitaria né tracciamenti comportamentali per finalità commerciali.",
          ],
        },
        {
          h: "4. Cookie di terze parti",
          p: [
            "La mappa integrata di Google Maps può impostare propri cookie durante la visualizzazione; per maggiori informazioni si rinvia alle policy di Google.",
            "I pulsanti verso i social network (Instagram, Facebook) possono impostare cookie dei rispettivi fornitori solo in caso di interazione diretta da parte dell'utente.",
          ],
        },
        {
          h: "5. Gestione dei cookie",
          p: [
            "È possibile cancellare o bloccare i cookie in qualsiasi momento tramite le impostazioni del proprio browser. La navigazione resta possibile anche bloccandoli, con eventuali limitazioni di alcune funzioni.",
          ],
        },
        {
          h: "6. Aggiornamenti",
          p: [
            "La presente cookie policy può essere aggiornata; si invita a consultare periodicamente questa pagina.",
          ],
        },
      ],
    },
  },
  en: {
    privacy: {
      eyebrow: "Legal information",
      title: "Privacy Policy",
      updated: "Last updated: 23/09/2026",
      back: "Back to Home",
      intro:
        "This notice describes how the personal data of visitors to the Ristorante Gunè showcase website is processed, under EU Regulation 2016/679 (GDPR).",
      sections: [
        {
          h: "1. Data controller",
          p: [
            "The data controller is Ristorante Gunè, based at Via XXV Aprile 80, 37014 Castelnuovo del Garda (VR), Italy — phone +39 045 640 2529.",
            "For any request concerning your data, please contact the controller using the details above.",
          ],
        },
        {
          h: "2. Data collected",
          p: [
            "The website is purely informational: there are no registrations, reserved areas or online purchases (no e-commerce).",
            "Personal data (name, phone number, possible email address, booking date and time and optional notes) is collected only through the booking request form, on a voluntary basis.",
          ],
        },
        {
          h: "3. Purpose and legal basis",
          p: [
            "Data is processed solely to handle booking requests and to contact the user to confirm the table.",
            "The legal basis is the execution of pre-contractual measures at the request of the data subject; further communications would require consent.",
          ],
        },
        {
          h: "4. Data retention",
          p: [
            "Data is kept only as long as necessary to handle the request and is then deleted or anonymised. No profiling or automated decision-making takes place.",
          ],
        },
        {
          h: "5. Disclosure to third parties",
          p: [
            "Data is never sold or disclosed. It may be processed by technical providers (e.g. hosting and database management) appointed as processors under Art. 28 GDPR.",
          ],
        },
        {
          h: "6. Data subject rights",
          p: [
            "Users may exercise at any time the rights of access, rectification, erasure, restriction, portability and objection (Art. 15-22 GDPR) by contacting the controller, and may lodge a complaint with the Italian supervisory authority (Garante Privacy).",
          ],
        },
        {
          h: "7. Updates",
          p: ["This notice may be updated at any time; please check this page periodically."],
        },
      ],
    },
    terms: {
      eyebrow: "Legal information",
      title: "Terms & Conditions",
      updated: "Last updated: 23/09/2026",
      back: "Back to Home",
      intro:
        "These terms govern the use of the Ristorante Gunè showcase website. Accessing and browsing the site implies their acceptance.",
      sections: [
        {
          h: "1. Purpose",
          p: [
            "The website has purely informational and promotional purposes: no online sales, payments or electronic contracts are provided (no e-commerce).",
          ],
        },
        {
          h: "2. Information, menu and images",
          p: [
            "Content, prices and dishes shown are for information only and may change over time; images are indicative.",
            "The full menu is provided through an external platform (thecubedesign.it) and opens in a new tab; Ristorante Gunè is not responsible for third-party website content, nor for Google Maps and integrated Google services.",
          ],
        },
        {
          h: "3. Booking requests",
          p: [
            "Submitting the booking form constitutes a mere request: a booking is confirmed only after the restaurant contacts the user by phone.",
          ],
        },
        {
          h: "4. Intellectual property",
          p: [
            "The logo, texts and photographs on this website belong to Ristorante Gunè or their legitimate owners and may not be reproduced without written authorisation.",
          ],
        },
        {
          h: "5. Limitation of liability",
          p: [
            "The controller does not guarantee the continuous availability of the website or the absence of errors or interruptions, and may amend content and these terms at any time.",
          ],
        },
        {
          h: "6. Governing law and jurisdiction",
          p: [
            "These terms are governed by Italian law. Any dispute is subject to the exclusive jurisdiction of the Courts of Verona, save for mandatory statutory competence.",
          ],
        },
      ],
    },
    cookies: {
      eyebrow: "Legal information",
      title: "Cookie Policy",
      updated: "Last updated: 23/09/2026",
      back: "Back to Home",
      intro: "This page explains what cookies are, which ones this website uses and how to manage them.",
      sections: [
        {
          h: "1. What cookies are",
          p: [
            "Cookies are small files saved on the user's device by the website through the browser: they support operation, remember preferences and collect aggregate statistics.",
          ],
        },
        {
          h: "2. Technical cookies",
          p: [
            "The website uses technical cookies and mechanisms required for it to work, such as saving the language preference (Italian/English). Being indispensable for the requested navigation, they do not require consent.",
          ],
        },
        {
          h: "3. Analytics cookies",
          p: [
            "The website may use aggregated, anonymised traffic analysis tools to understand how pages are used and improve the browsing experience.",
            "No advertising profiling cookies or behavioural tracking for commercial purposes are used.",
          ],
        },
        {
          h: "4. Third-party cookies",
          p: [
            "The embedded Google Maps may set its own cookies during display; please refer to Google's policies for details.",
            "Social network buttons (Instagram, Facebook) may set cookies from their respective providers only upon direct interaction by the user.",
          ],
        },
        {
          h: "5. Managing cookies",
          p: [
            "Cookies can be deleted or blocked at any time through browser settings. Browsing remains possible with them blocked, with possible limitations to some functions.",
          ],
        },
        {
          h: "6. Updates",
          p: ["This cookie policy may be updated; please check this page periodically."],
        },
      ],
    },
  },
};
